// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__SYa3o","insightsList":"newBusinessInsightsMenu_insightsList__cmWwz","active":"newBusinessInsightsMenu_active__31vEV"};